import React, { useState } from 'react';
import getConfig from 'next/config';
import { Form, Input, Checkbox, Button, message, Row, Col } from 'antd';
import styled from 'styled-components';

const RuleTextSpan = styled.span`
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.greyishBrown};
`;

const InfoText = styled.span`
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.86;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.primary};
`;

const ContactForm = ({ seoSlug }) => {
    const [messageSent, setMessageSent] = useState(false);
    const [messageIsSending, setMessageIsSending] = useState(false);

    const handleFinish = (values) => {
        message.loading({ content: 'Wysyłanie...', key: 'SendCompanyMessage' });
        setMessageIsSending(true);

        const { apiUrl } = getConfig().publicRuntimeConfig;
        fetch(`${apiUrl}/public/api/events/${seoSlug}/contact`, {
            method: 'post',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        }).then(() => {
            message.success({
                content: 'Wiadomość wysłana!',
                key: 'SendCompanyMessage',
                duration: 5
            });
            setMessageSent(true);
            setMessageIsSending(false);
        });
    };

    return (
        <Form onFinish={handleFinish} scrollToFirstError size="large">
            <Form.Item
                name="name"
                rules={[{ required: true, message: 'Wpisz poprawne imię i nazwisko' }]}
            >
                <Input
                    size="large"
                    placeholder="Imię i nazwisko*"
                    disabled={messageIsSending || messageSent}
                />
            </Form.Item>
            <Form.Item
                name="email"
                rules={[
                    { required: true, message: 'Wpisz poprawny adres e-mail' },
                    { type: 'email', message: 'Wpisz poprawny adres e-mail' }
                ]}
            >
                <Input
                    size="large"
                    placeholder="E-Mail*"
                    disabled={messageIsSending || messageSent}
                />
            </Form.Item>
            <Form.Item
                name="subject"
                rules={[{ required: true, message: 'Pole temat nie może być puste' }]}
            >
                <Input
                    size="large"
                    placeholder="Temat*"
                    disabled={messageIsSending || messageSent}
                />
            </Form.Item>
            <Form.Item
                name="text"
                rules={[{ required: true, message: 'Pole temat nie może być puste' }]}
            >
                <Input.TextArea
                    size="large"
                    rows={4}
                    placeholder="Treść*"
                    disabled={messageIsSending || messageSent}
                />
            </Form.Item>
            <Form.Item
                name="agreement"
                valuePropName="checked"
                rules={[
                    {
                        validator: (_, value) =>
                            value
                                ? Promise.resolve()
                                : Promise.reject(new Error('To pole jest wymagane!'))
                    }
                ]}
            >
                <Checkbox disabled={messageIsSending || messageSent}>
                    <RuleTextSpan>
                        Wyrażam zgodę na otrzymywanie informacji handlowej kierowanej do mnie za
                        pomocą środków komunikacji elektronicznej w szczególności poczty
                        elektronicznej zgodnie z przepisem art. 10 ust 2 ustawy z dnia 18 lipca 2002
                        roku o świadczeniu usług drogą elektroniczną (Dz. U. 144 z 2002 r. poz.
                        1204)*
                    </RuleTextSpan>
                </Checkbox>
            </Form.Item>
            <Row justify="end">
                <Col>
                    <InfoText>* Pola obowiązkowe</InfoText>
                </Col>
            </Row>
            <Form.Item>
                <Row justify="center">
                    <Col span={12}>
                        <Button
                            size="large"
                            block
                            type="primary"
                            htmlType="submit"
                            disabled={messageSent}
                            loading={messageIsSending}
                        >
                            Wyślij
                        </Button>
                    </Col>
                </Row>
            </Form.Item>
        </Form>
    );
};

export default ContactForm;
